import axios from 'axios';

const STORAGE_KEY = 'validatorData';
const RPC_ENDPOINT = 'https://berachain-v2-testnet-rpc.blacknodes.net/block';

const initialValidators = {
    "8A4553EF60BA7EF06E9AF196EC3FF7768077A186": { name: "BlackNodes" },
    "00C3B8DFAF3819DF26BFA0917D6FAC6B370C9896": { name: "Cosmostation" },
    "01FCF3BBE73C154A6ECD8BA4762D439768BE88E5": { name: "Luganodes" },
    "038C7C4734AD68E3A83487BE04C14AB4EC8D494E": { name: "B-Harvest" },
    "071E725312551D5F03E4B24CAC63E354B910E8EA": { name: "Restake" },
    "0B61F2D55C4EC7D62C5FDDE3B0C81FA0704FFE36": { name: "WhisperNode" },
    "195B9165C04135DED61E25857477C4A3C9E61707": { name: "Team #10" },
    "1A8177110622C5316E94E8A4FD6F23B4D1CB70A6": { name: "Golden Ratio Staking" },
    "1BADFD6B19D78A7A4FB78D59DAA0CA7745D8E0BE": { name: "InfStones" },
    "20D3CC45A56BD901E151A7CF4B79461994CDFD48": { name: "A41" },
    "21D6E143DF5AF2D863D1432F97BDCFC79ECE2133": { name: "Team #7" },
    "251955C24EBA1A44EF912A10169CE84E8359C704": { name: "Team #12" },
    "262CE6F34177DF645FC9472712E794F8FADED0A1": { name: "Team #2" },
    "29C82FDA5A5E051DFDF62AEA9FBAE3CCE6393B55": { name: "Team #4" },
    "2BA3B1D9A8BF19B1FF4B14B7E1575757C772123E": { name: "RHINO" },
    "2CB94215E7A0C2168DAE0805431C263A7B5A1E82": { name: "BlockPI Network" },
    "2EDC26CB83D155007D7DEB5A8F52AB7FA79FC23B": { name: "Nodeinfra" },
    "2EE9B9E23BC14C4E29886BCB754AA88C50480EEF": { name: "DeSpread" },
    "312D25050722ED2DB33FD47D46EE15E0EF164672": { name: "BCW" },
    "3306C53D0795CB9E9C160EAE3F6BDB50DBECB916": { name: "Provalidator" },
    "3835ABB96DD933585D15DACDB9195473106DA46A": { name: "KysenPool" },
    "3A0EEE34FE577E6E433357137246EE694F0F7B03": { name: "KudasaiJP" },
    "43A0A634552F01F7F6AB45AEF2B8CF85E8ABB2B7": { name: "moni" },
    "4C3956C3ACB7DD2052C1183B4D1EDE143D471113": { name: "01node" },
    "520C1B0105178B9372E309DEC3E0CAE19E376766": { name: "Imperator.co" },
    "54CA081A30DE94B71AEA41C0BED919EEF5342F90": { name: "54CA0...2F90" },
    "551C7DEB6671A25C495FF0B094C06B24E119EB51": { name: "551C7...EB51" },
    "5B2ADB5655CFB87530D2063052635EA3EF9F1C16": { name: "Nodes.Guru" },
    "6005BF8666BE2D4CC1793DDC7968B549A7D76459": { name: "beraland" },
    "65808D47BA81F2E3842D7300C1EB9265F11F5D3B": { name: "Republic Crypto" },
    "692114EB14C870FB1E827D042BE122C84DDDD2D2": { name: "Forest Staking" },
    "6B3AC0D11B1C5D42B27C065CC1C6FC63542FC52E": { name: "StakeUs" },
    "6BDE137EBAE3BF317C8CF1C155F55677C772A40A": { name: "Kiln" },
    "6E5C56EAEBFF1A0796375FD342961948385DBFD4": { name: "Allnodes" },
    "71170441CD7F2FE816DFC99B30808992D66CC40A": { name: "polkachu" },
    "74124C3D8434409D6AEB321F28E4829ABA361309": { name: "DSRV" },
    "748BB22263083CA54ECD3EE106975F465D24FD1D": { name: "TTT 🇻🇳" },
    "7590A35DC43FC87463E0DC414D44E0706F17BE71": { name: "Team #13" },
    "76B2409AA88DB19A04442B9B4236CA06CB490C0E": { name: "Team #8" },
    "7E1E18AF8C98B0E6C65484904FA34AB8C494612C": { name: "verse2" },
    "81081E57C435C62078158401C690F8F0CAA8BB7D": { name: "Synergy Nodes" },
    "823D6DD864D161ED517C40B41EDFDF48F515C0E6": { name: "Team #3" },
    "83288B99CE00064724D65579AB90A9415ED2C914": { name: "BCW" },
    "836647B1A401FC910334BBB4247032ABCA3DE320": { name: "Team #15" },
    "8C1C7CF47BC0839C64BCAFD7573DA9242744F396": { name: "StakingCabin" },
    "9008C4AE7AC48010E7FB70A0F72191FCACAB641A": { name: "Team #5" },
    "9B12FC719D7C235EC8806B88BEDCF881971CFCB5": { name: "Team #6" },
    "9D17697A0C15D06555F5A84C7EFA54FE5AA9FD5A": { name: "[NODERS]TEAM" },
    "9D6AA2B8796650B780071C2AEC36FF1F6E99E181": { name: "infrared.finance" },
    "A484B12E2041ED1FEABD44CCCF9A17439DC61D98": { name: "node101" },
    "A5BD95B858F396C2E059343D3E5690D9D6086657": { name: "Flipside" },
    "A8C0F088C1E1347024034E8A6A50548FEA35E4DC": { name: "StakeLab" },
    "ACCB214D3DA57906E466B212CC542EC0BBE1EF1E": { name: "Asymmetric Research" },
    "B35BF29559EDD4A4DCC8B068B01C5A606572C53E": { name: "Team #1" },
    "B45E2A9B2D822E3598437A9AFECD2657D273E3D8": { name: "Stakely" },
    "B4625A13D3DCE869596FAC1EB2253B8842A2F4D0": { name: "Coinage x DAIC" },
    "B71E09197968B543716071648483EC57E97D7264": { name: "RockawayX Infra" },
    "BAB36710BD225EA798818621583F013C95267C2E": { name: "Pier Two" },
    "BD0ABA1B739FCED6F28D23E4B534A283DE27B15C": { name: "kingnodes" },
    "BE98157D97DD380753EF2A568BA74EF3F0E47193": { name: "Citadel.one" },
    "C3AFDE56A8906388934119ED4989A385DFF6381C": { name: "L0vd" },
    "C5ED73A6631760D47CB599909C4D0D92AF4C2ABC": { name: "Shinlabs" },
    "C65C16597C82BB91F0BED5A3862E4F4E507D048C": { name: "SenseiNode" },
    "C7B91A2BCB10D562CAA35EFD695B9C49F4F8BB84": { name: "DOUBLETOP" },
    "C8F0CE9024946E62D283F3112D9273386E251959": { name: "Brightlystake" },
    "C9261242225585C60A398B28FC4459EABC37ADA7": { name: "P-OPS Team" },
    "CB3D3F4A82B6FA907656D064C9163842AFD0DAEE": { name: "Staked" },
    "CC5504728BC484671D25B55A41769FB92A290B0D": { name: "Kintsugi" },
    "D36FCE16B1630CA26ADC856A52BF30B6AA003F8A": { name: "Team #9" },
    "D588A58ADBA5BD51BEF7E1BEA742B0C8794F2E32": { name: "Team #11" },
    "D7E09381FF8385556FC648729BC3C3977DE49379": { name: "Figment" },
    "D820CA8F8EF1FA156AAD118346D88334555B99E7": { name: "Jetking" },
    "D9ED770DE0106B3F2BDFD0D74DB8923C1A5A2ECA": { name: "Meria" },
    "DACECF872FC744E585ACED198D8A1EE112C40F66": { name: "QuantNode" },
    "DF489DC55086113B54F08C78D215A05B98938FF9": { name: "Node Guardians" },
    "E23792E72AC6FB1B3811A8711329241D0182A489": { name: "Staketab" },
    "E2DD3F50FCC830FCCA2CA6B9AA35CF56F1E4BEEC": { name: "Enigma" },
    "E485B0DC584432CDE20CA95724A4CFAA1A94218B": { name: "Lavender.Five Nodes" },
    "E4D8E3C0D60A55AE2DEBEB21ED50EC2A5428A2A2": { name: "1XP" },
    "E65B2601BD18DE285E9F476B508C5CC47E3689B2": { name: "H2O Nodes" },
    "E8557AAA1C63C965AC654FB59AD5349FA414D2E8": { name: "Nocturnal Labs" },
    "EB978497C6D942A91404548E518EE92561C7A044": { name: "EB978...A044" },
    "EBD08086031F02EC4DB22FC76FD10F4F6B895EAE": { name: "Team #14" },
    "F0BCEFEA62ECA2831BA87268F5A9C6FD4E4A2F03": { name: "Team #16" },
    "F79FCD1240E86778017D2DA727178B749E8DC9AD": { name: "Informal Systems" },
    "F80C9BB1C9ED61E3D3343590F1A56200A51A1E1A": { name: "SimplyStaking" },
    "FA28C766E2CEBC5F0CAFF1C870DAD9A2D9D4B547": { name: "MantiCore" },
    "FC6174EEE30044917013D7117A0D7DE79992BE3B": { name: "Twinstake" },
    "301E6FB8ADB311FDB3B9A4A3A986EFC986C69969": { name: "301E6...9969" },
    "12D8CD0B8C92954FE8482E02BCA0D9C08CF80732": { name: "12D8C...0732" },
    "BB6B95CB66AEE3D6CF4026956889EBB203FD157F": { name: "BB6B9...157F" },
    "6AF2CD085D9F9EB1E1634A1238067D7B6367892D": { name: "6AF2C...892D" },
    "7D11D225AF2F86F75F624B24210DC1576AD9F8EA": { name: "7D11D...F8EA" },
    "A308433274D6EFE272106888A3E957966B70A73B": { name: "A3084...A73B" },
    "6492D074A7EB40549FF0A67B6C78AAE79D619505": { name: "6492D...9505" },
    "9CFE2DF30A71BE3A7170198CBFB39D77999B53E7": { name: "9CFE2...53E7" },
    "11BEFA71FF4A8EDC1CE2844BF0BD87A1DC1517F7": { name: "11BEF...17F7" },
    "B2A5C37E25E52A994550C504E4227A9CBB60F61A": { name: "B2A5C...F61A" },
    "24A6EE555CD835C43992008C35DFAAB3323BAB21": { name: "24A6E...AB21" },
    "5165E9A20C7526F2FE2C9A4C60D57A15F6BBEE01": { name: "5165E...EE01" },
    "DBF734FC77CCBC55DEA835E950C0AB2717F755ED": { name: "DBF73...55ED" },
    "33C03CD4F7A38FE7C81EED8ED33C789E40718119": { name: "33C03...8119" },
    "1D2C30DBA0983095D95FAEBABD57B1EF96CB07FB": { name: "1D2C3...07FB" },
    "902EEA7615635805D2AEAFCCF474942D4D36EC36": { name: "902EE...EC36" },
    "136ED761C49DCD7685F3D81136E7FB4DFCBBE891": { name: "136ED...E891" },
    "C333B4012DC0C8DB5FDA5D6C3CB72FE1CFB63EE9": { name: "C333B...3EE9" },
    "3CC1ADB0F1F0083251E91ED680EDE394703BEBDB": { name: "3CC1A...EBDB" },
    "679CFC5C6D84635B1CC02506FA9B5C9C9D60C681": { name: "679CF...C681" },
    "7E089264DEC0CAE63E7A75DF1112C3448650BB23": { name: "Laminated Labs" },
    "F5D60ED4078E6CBFF72A6BC72CD879FA9AB2F535": { name: "F5D60...F535" },
    "E4CF70CB6DBEF3B4DD277CAC5E56E16F736D5383": { name: "E4CF7...5383" },
    "DBF4F386134F2921088ED09BD1C93F3820FA3657": { name: "DBF4F...3657" },
    "5D71EA561CDE9CA3AD683F6C715CAC8B193A6583": { name: "5D71E...6583" },
    "886C0C30B579391E270CE6F6C2F887DD493DE739": { name: "886C0...E739" },
    "A04439CD1EDE1221895AA95788B43570E113CC46": { name: "A0443...CC46" },
    "8BC9CB4C51A7AC47DEB10AE309DDB14709B124B8": { name: "8BC9C...24B8" },
    "A37A787F38C0B3EA65CE52265EF33D8F8DA86C65": { name: "A37A7...6C65" },
    "21F5CE08E5B039E9C78C47864DBB943940D886B8": { name: "21F5C...86B8" },
    "B0A80FA142F710670F6FC2E820E5A5CF00296F66": { name: "B0A80...6F66" },
    "406CF65233D6DDF34CE36E015B2DEA040804EC0B": { name: "406CF...EC0B" },
    "5502A53095EA0D02CDE78BF82A0C20F7DD99C128": { name: "5502A...C128" },
    "7C5DBE3BB628FF8C79B6EABDEBBD9ECD78ECA258": { name: "7C5DB...A258" },
  };

let validatorData = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {
  lastProcessedBlock: 0,
  validators: {}
};

// Ensure all validators are present in the data
Object.entries(initialValidators).forEach(([address, data]) => {
  if (!validatorData.validators[address]) {
    validatorData.validators[address] = {
      ...data,
      blocksSigned: 0,
      blocksProposed: 0,
      expectedSigns: 0
    };
  }
});

function saveData() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(validatorData));
  console.log('Data saved:', validatorData);
}

async function updateValidatorData() {
  try {
    console.log('Updating validator data...');
    const response = await axios.get(RPC_ENDPOINT);
    const block = response.data.result.block;
    const newBlockHeight = parseInt(block.header.height);

    console.log('New block height:', newBlockHeight);
    console.log('Last processed block:', validatorData.lastProcessedBlock);

    if (newBlockHeight <= validatorData.lastProcessedBlock) {
      console.log('No new blocks to process');
      return;
    }

    const blocksToProcess = newBlockHeight - validatorData.lastProcessedBlock;
    const proposerAddress = block.header.proposer_address;
    const signers = new Set(block.last_commit.signatures
      .filter(sig => sig.block_id_flag === 2)
      .map(sig => sig.validator_address));

    console.log('Proposer:', proposerAddress);
    console.log('Signers:', signers);

    // Update data for each validator
    Object.keys(validatorData.validators).forEach(address => {
      validatorData.validators[address].expectedSigns += blocksToProcess;
      if (signers.has(address)) {
        validatorData.validators[address].blocksSigned += blocksToProcess;
        console.log(`${validatorData.validators[address].name} signed ${blocksToProcess} blocks`);
      }
      if (address === proposerAddress) {
        validatorData.validators[address].blocksProposed++;
        console.log(`${validatorData.validators[address].name} proposed block`);
      }
    });

    validatorData.lastProcessedBlock = newBlockHeight;
    saveData();
    console.log('Updated validator data:', validatorData);
  } catch (error) {
    console.error('Error updating validator data:', error);
  }
}

function getValidatorStats() {
  const maxProposed = Math.max(...Object.values(validatorData.validators).map(v => v.blocksProposed));

  return Object.entries(validatorData.validators).map(([address, data]) => ({
    address,
    name: data.name,
    uptime: data.expectedSigns > 0 
      ? Math.min((data.blocksSigned / data.expectedSigns * 100), 100).toFixed(2) 
      : '0.00',
    proposedPercentage: maxProposed > 0 
      ? (data.blocksProposed / maxProposed * 100).toFixed(2) 
      : '0.00',
  }));
}

// Start updating data periodically
setInterval(updateValidatorData, 5000);

// Initial update
updateValidatorData();

export { getValidatorStats, validatorData };